import React from "react";

export const UserIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none">
      <path
        d="M12.1816 13C14.9431 13 17.1816 10.7614 17.1816 8C17.1816 5.23858 14.9431 3 12.1816 3C9.42022 3 7.18164 5.23858 7.18164 8C7.18164 10.7614 9.42022 13 12.1816 13Z"
        stroke="black"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M20.1816 21C20.1816 18.8783 19.3388 16.8434 17.8385 15.3431C16.3382 13.8429 14.3034 13 12.1816 13C10.0599 13 8.02508 13.8429 6.52479 15.3431C5.0245 16.8434 4.18164 18.8783 4.18164 21"
        stroke="black"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
